"use client";

import { getTranslatedLink } from "@/components/UI/Link/TranslatedLink";
import { useI18n } from "@/i18n/client";
import Link from "@/components/UI/Link/Link";
import { FC } from "react";
import styles from "./Tags.module.scss";
import { ArticleEntryType } from "@/lib/builder/server-queries";
import { normalizeTags } from "@/lib/builder/builder-utils";

interface TagsProps {
	location: ArticleEntryType;
	tags: Array<string> | string | Record<string, unknown> | null | undefined;
}

const Tags: FC<TagsProps> = ({ tags, location }) => {
	const normalizedTags = normalizeTags(tags);

	const t = useI18n();

	if (normalizedTags.length === 0) {
		return null;
	}

	return (
		<div className={styles.tags}>
			{normalizedTags.map((tag: string, index: number) => {
				const tagChecker = `?${t("Blog.tag").toLowerCase()}=${tag}`;

				return (
					<Link
						key={`${tag}-${index}`}
						className={styles.item}
						href={`${getTranslatedLink({ href: location })}${tagChecker}`}
						aria-label={`${t("Blog.viewAllArticlesOn")}${tag}`}
					>
						{tag}
					</Link>
				);
			})}
		</div>
	);
};

export default Tags;
